import { DEFAULT_PERIOD } from "@constants";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  period: DEFAULT_PERIOD,
  periods: [],
  city: "todas",
  npsSegment: "",
  clientType: "",
  beneficiaryType: "todos",
  dateRange: { start: null, end: null },
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setPeriod(state, action) {
      state.period = action.payload;
    },
    setPeriods(state, action) {
      state.periods = action.payload;
    },
    setCity(state, action) {
      state.city = action.payload;
    },
    setNpsSegment(state, action) {
      state.npsSegment = action.payload;
    },
    setClientType(state, action) {
      state.clientType = action.payload;
    },
    setBeneficiaryType(state, action) {
      state.beneficiaryType = action.payload;
    },
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const {
  setPeriod,
  setPeriods,
  setCity,
  setNpsSegment,
  setClientType,
  setBeneficiaryType,
  setDateRange,
  resetFilters,
} = filtersSlice.actions;
export const selectFilters = (state) => state.filters;
export const selectPeriod = (state) => state.filters.period;
export const selectCity = (state) => state.filters.city;
export const selectNpsSegment = (state) => state.filters.npsSegment;
export const selectClientType = (state) => state.filters.clientType;
export const selectBeneficiaryType = (state) => state.filters.beneficiaryType;
export default filtersSlice.reducer;
